"use client";

import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";

import { RootContent, type RootContentProps } from "./root-content";

// Словарь каждой локали — свой чанк (KAN-973). Статический импорт обеих обёрток
// Turbopack склеивал в один чанк на ~1 МБ с обоими языками; next/dynamic при SSR
// сам ставит preload чанка той локали, что отрендерилась, — лишнего round-trip нет.
const RootContentRu = dynamic(() => import("./root-content-ru").then((m) => m.RootContentRu));
const RootContentEn = dynamic(() => import("./root-content-en").then((m) => m.RootContentEn));

// Оверлей для OBS рисуется без провайдера переводов — словарь ему не нужен вовсе.
// Сырой usePathname из next/navigation: провайдера next-intl выше нет (см. root-content).
const NO_MESSAGES = {};

export function RootContentLocale({
  locale,
  ...props
}: Omit<RootContentProps, "messages">) {
  if (usePathname() === "/overlay") {
    return <RootContent {...props} locale={locale} messages={NO_MESSAGES} />;
  }
  return locale === "en" ? <RootContentEn {...props} /> : <RootContentRu {...props} />;
}
